import useGlobalContext from './useGlobalContext'

export const useCurrentLocationIndex = () => {
  const context = useGlobalContext()

  return context?.locationIndex ?? undefined
}

export default useCurrentLocationIndex
